export default "__VITE_ASSET__BUxfSLjI__"